<div class="profile-preview__section" id="data-space">
  <mh-profile-section-header
    iconType="database"
    titleText="Data space attributes"
    [isCollapsed]="isCollapsed"
    sectionId="data-space"
    (toggle)="onToggle()"
  ></mh-profile-section-header>
  <div class="profile-preview__section-content" [hidden]="isCollapsed">
    <ng-container *ngFor="let group of dataSpaceAttributes">
      <div class="dataspace-group" *ngIf="!group.empty">
        <h3 class="dataspace-group-title">{{ group.dataspaceName }} (ID: {{ group.dataspaceId }})</h3>
        <div class="dataspace-group-content">
          <ng-container *ngFor="let attr of group.attributes">
            <mh-data-space-attribute-view
              nz-row
              [attr]="attr"
              class="profile-preview__section-content-row"
            ></mh-data-space-attribute-view>
          </ng-container>
        </div>
      </div>
    </ng-container>
  </div>
</div>
